import { Injectable } from "@angular/core";

export type AiAgentShellMode = "docked" | "detached";

export interface AiAgentShellState {
  open: boolean;
  mode: AiAgentShellMode;
  /** Detached window position (px from viewport top-left). */
  x: number;
  y: number;
}

const STORAGE_KEY = "dws.ai-agent.shell.v1";

@Injectable({ providedIn: "root" })
export class AiAgentShellStore {
  load(): AiAgentShellState {
    const defaults = this.defaults();
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return defaults;
      }
      const parsed = JSON.parse(raw);
      return {
        open: !!parsed?.open,
        mode: parsed?.mode === "detached" ? "detached" : "docked",
        x: typeof parsed?.x === "number" ? parsed.x : defaults.x,
        y: typeof parsed?.y === "number" ? parsed.y : defaults.y,
      };
    } catch {
      return defaults;
    }
  }

  save(state: AiAgentShellState): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
      /* ignore */
    }
  }

  defaults(): AiAgentShellState {
    const w = typeof window !== "undefined" ? window.innerWidth : 1200;
    const h = typeof window !== "undefined" ? window.innerHeight : 800;
    return {
      open: false,
      mode: "docked",
      x: Math.max(24, w - 440),
      y: Math.max(72, h - 640),
    };
  }
}
